<ng-template
  #headerTemplate
  let-titleLocalization="titleLocalization"
  let-subTitleLocalization="subTitleLocalization"
  let-selectionPhase="selectionPhase"
  let-numberOfBound="numberOfBound"
>
  <div
    data-testid="header-template"
    class="pr-large-t"
    [ngClass]="{
      'df-tablet-up flex--space-between flex--row-reverse': enableNewLanguageSelector && !enableNewStepper,
    }"
  >
    <div *ngIf="enableNewLanguageSelector && !enableNewStepper" class="ms-xxsmall-t ps-xsmall-r ps-small-b align-right">
      <fin-language-selector [context]="LANGUAGE_SELECTOR_CONTEXT" [showWarning]="false"></fin-language-selector>
    </div>
    <fin-booking-plain-header-area
      [enableTopPadding]="!enableNewLanguageSelector"
      [enableBottomPadding]="(outbound$ | async) !== undefined"
      [title]="
        numberOfBound +
        (titleLocalization
          | finLocalization
            : {
                origin: tripLocations?.[BOUND_SELECTION_PHASE_INDEX[selectionPhase]]?.origin,
                destination: tripLocations?.[BOUND_SELECTION_PHASE_INDEX[selectionPhase]]?.destination,
              })
      "
      [subtitle]="
        subTitleLocalization
          | finLocalization
            : {
                currencyCode: currencyCode$ | async,
                passengerTypes: 'passenger' | finLocalization | finFormatPassenger: (paxAmount$ | async),
              }
      "
    ></fin-booking-plain-header-area>
  </div>
</ng-template>
<div class="ticket-selection-header-content overflow-hidden">
  <div
    class="font-body-1 title-animate nowrap fill phase__{{ selectionPhase$ | async }}"
    [ngClass]="{ oneway: isOneWay$ | async }"
  >
    <div class="inline-block fill" [attr.aria-hidden]="(selectionPhase$ | async) !== SelectionPhase.OUTBOUND">
      <ng-container
        *ngTemplateOutlet="
          headerTemplate;
          context: {
            numberOfBound: (isOneWay$ | async) === false ? (this.numberOfBoundText$ | async) : '',
            titleLocalization: 'ticketSelection.header.selectBound',
            subTitleLocalization:
              (isOneWay$ | async)
                ? 'ticketSelection.header.pricesForPaxWithCurrency'
                : 'ticketSelection.header.pricesForDirectionWithCurrency',
            selectionPhase: (selectionPhase$ | async),
          }
        "
      ></ng-container>
    </div>
    <div
      *ngIf="(isOneWay$ | async) !== true"
      class="inline-block fill"
      [attr.aria-hidden]="(selectionPhase$ | async) !== SelectionPhase.INBOUND"
    >
      <ng-container
        *ngTemplateOutlet="
          headerTemplate;
          context: {
            numberOfBound: (this.numberOfBoundText$ | async),
            titleLocalization: 'ticketSelection.header.selectBound',
            subTitleLocalization: 'ticketSelection.header.pricesForDirectionWithCurrency',
            selectionPhase: (selectionPhase$ | async),
          }
        "
      ></ng-container>
    </div>
    <div class="inline-block fill">
      <ng-container
        *ngTemplateOutlet="
          headerTemplate;
          context: {
            numberOfBound: '',
            titleLocalization: 'ticketSelection.header.selectTicketType',
            subTitleLocalization: 'ticketSelection.header.pricesForDirectionWithCurrency',
          }
        "
      ></ng-container>
    </div>
  </div>
</div>

<fcom-notification
  data-testid="promo-code-notification"
  *ngIf="promoCode$ | async as promoCode"
  class="pr-small-b"
  [theme]="NotificationTheme.SUCCESS"
>
  {{ 'promoCode.applied' | finLocalization: { code: promoCode } }}
</fcom-notification>

<fin-booking-notification [isFullWidth]="false" [theme]="NotificationTheme.SUCCESS"></fin-booking-notification>

<div class="ticket-selection-header grey-25-bg mobile-bleed">
  <button
    #outboundButton
    *ngIf="outbound$ | async"
    class="bound-button fill"
    [class.state-foreground]="(selectionPhase$ | async) === SelectionPhase.OUTBOUND"
    [class.state-background]="(selectionPhase$ | async) === SelectionPhase.INBOUND && (outbound$ | async)"
    [class.state-disabled]="(selectionPhase$ | async) === SelectionPhase.INBOUND && !!(outbound$ | async) !== true"
    [disabled]="(selectionPhase$ | async) !== SelectionPhase.OUTBOUND && !!(outbound$ | async) !== true"
    (click)="clickOutbound.emit()"
    [finElemTracker]="'change-outbound'"
    [finElemState]="((outbound$ | async) ? 'filled' : 'empty') + '-enabled'"
    [finElemContext]="TRACKING_CONTEXT"
    [finElemType]="C.ElementTypes.BUTTON"
  >
    <fin-bound-container
      [bound]="outbound$ | async"
      [label]="'ticketSelection.departure' | finLocalization"
      [date]="departureDate$ | async"
      [active]="(selectionPhase$ | async) !== SelectionPhase.INBOUND"
    ></fin-bound-container>
  </button>
  <ng-container *ngIf="(isOneWay$ | async) !== true">
    <button
      *ngIf="inbound$ | async"
      #inboundButton
      class="bound-button fill"
      [class.state-foreground]="(selectionPhase$ | async) === SelectionPhase.INBOUND"
      [class.state-background]="(selectionPhase$ | async) === SelectionPhase.OUTBOUND && (inbound$ | async)"
      [class.state-disabled]="(selectionPhase$ | async) === SelectionPhase.OUTBOUND && !!(inbound$ | async) !== true"
      [disabled]="(selectionPhase$ | async) !== SelectionPhase.INBOUND && !!(inbound$ | async) !== true"
      (click)="clickInbound.emit()"
      [finElemTracker]="'change-inbound'"
      [finElemState]="((inbound$ | async) ? 'filled' : 'empty') + '-enabled'"
      [finElemContext]="TRACKING_CONTEXT"
      [finElemType]="C.ElementTypes.BUTTON"
    >
      <fin-bound-container
        [bound]="inbound$ | async"
        [label]="'ticketSelection.return' | finLocalization"
        [date]="returnDate$ | async"
        [active]="(selectionPhase$ | async) !== SelectionPhase.OUTBOUND"
        [disabled]="(selectionPhase$ | async) === SelectionPhase.OUTBOUND"
      ></fin-bound-container>
    </button>
  </ng-container>
</div>
